import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  useRecordContext,
  useGetOne,
} from 'react-admin';
import { Box, Skeleton } from '@mui/material';
import { Business as PlantIcon } from '@mui/icons-material';

// Muestra la planta con trazado completo
const PlantField = ({ source }: { source: string }) => {
  const record = useRecordContext();
  const tableId = record?.[source]; // tableId del dispositivo

  // Obtiene la tabla
  const { data: table, isLoading: isLoadingTable, error: tableError } = useGetOne(
    'tables',
    { id: tableId },
    { enabled: !!tableId }
  );

  // Obtener la zona
  const { data: zone, isLoading: isLoadingZone, error: zoneError } = useGetOne(
    'zones',
    { id: table?.zoneId },
    { enabled: !!table?.zoneId }
  );

  // Obtiene la planta
  const { data: plant, isLoading: isLoadingPlant, error: plantError } = useGetOne(
    'plants',
    { id: zone?.plantId },
    { enabled: !!zone?.plantId }
  );

  const isLoading = isLoadingTable || isLoadingZone || isLoadingPlant;
  const hasError = tableError || zoneError || plantError;

  if (!tableId) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <PlantIcon fontSize="small" color="disabled" />
        <span style={{ color: '#999' }}>Sin planta asignada</span>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width={100} />
      </Box>
    );
  }

  if (hasError || !plant) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <PlantIcon fontSize="small" color="error" />
        <span style={{ color: '#f44336' }}>Error cargando planta</span>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <PlantIcon fontSize="small" color="primary" />
      <span>{plant.plantName || plant.name || `Planta ${plant.id}`}</span>
    </Box>
  );
};

const DevicesShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source='id' />
      <TextField source='variableName' />
      <TextField source='deviceId' />
      <TextField source='deviceType' />
      <TextField source='ipAddress' />
      {/* Muestra la planta a través de tableId */}
      <PlantField source="tableId" label="Plant" />
    </SimpleShowLayout>
  </Show>
);

export default DevicesShow;